import service from '../util/axios';

export const homeList = data => {
  return service({
      method: 'POST',
      url: '/home/list',
      data
  })
}

export const productList = data => {
  return service({
      method: 'POST',
      url: '/module/list',
      data
  })
}

// product查询
export const productDatas = data => {
  return service({
      method: 'POST',
      url: '/module/datas',
      data
  })
}


export const contactAdd = data => {
  return service({
      method: 'POST',
      url: '/relation/add',
      data
  })
}
